/** Capability proof points for the Home hero strip (`SocialProof`) and the
 * Home stats grid (`STATS` in `content/home.ts`, same four facts as
 * value/label pairs). Deliberately capability claims, not customer names —
 * Workshop has no public customer logos to show yet. */
export interface ProofPoint {
  label: string;
}

export const PROOF_POINTS: ProofPoint[] = [
  { label: "Isaac Sim 6.0.1 · PhysX 6-DOF" },
  { label: "NVIDIA DGX Spark · GB10" },
  { label: "4/4 gated GPU validation" },
  { label: "Analytic ⇄ Isaac Δ < 0.5 m" },
];
